import Hammer from "hammerjs";
import AppSettings from "../../../AppSettings";
import defaultSignature from "../assets/images/default_signature.svg";


export default class SignatureUtils {
  constructor(el) {
    this.el = el;
  }

  // default signature
  applyDefaultSignature( signatureCoverage, $defaultSignatureCanvas) {
    let defaultFinalSignature;

    if(AppSettings.isSkinSpecificCustomization()) {
      if(AppSettings.designerSettings.SkinSpecificCustomization.DefaultSignature) {
        defaultFinalSignature = AppSettings.designerSettings.SkinSpecificCustomization.DefaultSignature.URL;
      } else {
        defaultFinalSignature = defaultSignature;
      }
      
    } else {
      defaultFinalSignature = defaultSignature;
    }
   
    const defaultSignatureCtx = $defaultSignatureCanvas.getContext("2d");
    const signatureImg = new Image();
    signatureImg.onload = function () {
      defaultSignatureCtx.drawImage(
        signatureImg,
        signatureCoverage.x,
        signatureCoverage.y,
        signatureCoverage.width,
        signatureCoverage.height
      );
    };
    signatureImg.src = defaultFinalSignature;
  }


  // show optimization popup
  showOptimisationPopup(currentViewPage) {
    const canvasDOM = this.el.querySelector("#ssg-canvas");
    //Fallback - If hammer doesn't work on mouse event
    canvasDOM.addEventListener("dblclick", () => {
      showOptimisationPopup();
    });

    // Gratefully - its also working on mouse event with touch event
    const mc = new Hammer.Manager(canvasDOM);
    const tap = new Hammer.Tap({ event: "doubletap", taps: 2 });
    mc.add(tap);
    mc.on("doubletap", () => {
      showOptimisationPopup();
    });

    const showOptimisationPopup = () => {
      currentViewPage.setActiveView("view-svgOptimisation-wrapper");
      currentViewPage.addClassToView("referrer-designer-view");
      /* Why we need the hide class for metal? hr
      todo:  we have to keep same method for both metal */
      this.el.querySelector(".optimisation-popup-container").classList.remove('hide');
      this.el.querySelector(".optimisation-popup-container").style.display =
        "flex";
    };
  }
}
